import React from 'react';
import { HorizontalBar } from 'react-chartjs-2';
import { Card, CardBody, CardHeader } from 'reactstrap';

const SellerPerformanceChart = ({ bySeller }) => {
  if (!bySeller || bySeller.length === 0) return null;

  const sorted = [...bySeller].sort((a, b) => b.count - a.count).slice(0, 10);

  const data = {
    labels: sorted.map((s) => s.seller),
    datasets: [
      {
        label: 'Ventas',
        data: sorted.map((s) => s.count),
        backgroundColor: '#acc236',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [
        {
          ticks: { beginAtZero: true, precision: 0 },
        },
      ],
    },
    legend: { display: false },
  };

  return (
    <Card className="mb-4">
      <CardHeader>Rendimiento por Vendedor</CardHeader>
      <CardBody style={{ height: Math.max(200, sorted.length * 40) + 'px' }}>
        <HorizontalBar data={data} options={options} />
      </CardBody>
    </Card>
  );
};

export default SellerPerformanceChart;
